/** Copyright (c) 2019 T. Rowe Price. All rights reserved. */

import './ModalLoadingSpinner.scss';

import { string } from 'prop-types';
import React from 'react';

import { Spinner } from '@trp-beacon-ui-kit/react-communication';

const ModalLoadingSpinner = ({ label }) => (
  <div className="modal-loading-component-overlay">
    <div className="modal-loading-text">{label}</div>
    <Spinner />
  </div>
);

ModalLoadingSpinner.propTypes = {
  label: string.isRequired
};

export default ModalLoadingSpinner;
